import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Toaster } from "vue-sonner";
import "vue-sonner/style.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Toaster), {
    position: "top-right",
    duration: 5000,
    toastOptions: {
      classes: {
        toast: 'custom-toast-item',
        title: 'custom-toast-title',
        description: 'custom-toast-description',
        success: 'custom-toast-success',
        error: 'custom-toast-error',
        warning: 'custom-toast-warning',
        info: 'custom-toast-info',
        closeButton: 'custom-toast-close',
      },
    },
    richColors: "",
    closeButton: ""
  }))
}
}

})